export const generatePathFromMenuName = (name: string) => {
    const pathRegex = /[^0-9a-zA-Z_\-]/g;
    return name.replace(pathRegex, '').split(' ').join('').toLowerCase();
};

export const slugify = (text: string, separator = '-') => {
    return text
        .toString()
        .normalize('NFD') // split an accented letter in the base letter and the acent
        .replace(/[\u0300-\u036f]/g, '') // remove all previously split accents
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9 ]/g, '') // remove all chars not letters, numbers and spaces (to be replaced)
        .replace(/\s+/g, separator);
};

export const stringAvatar = (name: string) => {
    if (!name) {
        return {
            children: '',
        };
    }
    if (name.split(' ').length > 1) {
        return {
            children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`.toUpperCase(),
        };
    }
    return {
        children: `${name[0]}${name[1]}`.toUpperCase(),
    };
};
